import classnames from 'classnames2';
import React, { forwardRef } from 'react';
import styles from './ScrollShadow.scss';

var shadowCoverBackgroundColor = function shadowCoverBackgroundColor(props) {
  switch (props.backgroundColor) {
    case 'gray-100':
      return styles.shadowCoverLinearGradientGray100;

    case 'white':
    default:
      return styles.shadowCoverLinearGradientWhite;
  }
}; // tslint:disable:no-shadowed-variable
// tslint:disable-next-line:no-function-expression


export var ScrollShadow = forwardRef(function ScrollShadow(props, forwardedRef) {
  return React.createElement("div", {
    className: styles.shadowOverlay
  }, React.createElement("div", {
    className: styles.shadowContainer
  }, React.createElement("div", {
    className: styles.shadowBelow
  }), React.createElement("div", {
    className: styles.shadowAbove
  })), React.createElement("ul", {
    ref: forwardedRef,
    className: classnames(styles.shadowList, props.className),
    style: {
      maxHeight: props.height,
      minHeight: props.minHeight || 0
    },
    role: props.role,
    "aria-label": props.ariaLabel,
    tabIndex: 0,
    onKeyDown: props.onKeyDown,
    onFocus: props.onFocus,
    onClick: props.onClick,
    onBlur: props.onBlur,
    onMouseDown: props.onMouseDown,
    "aria-multiselectable": props.ariaMultiselectable ? true : null,
    "aria-activedescendant": props.ariaActiveDescendent
  }, React.createElement("li", {
    id: "scrollShadowTop",
    "aria-hidden": true,
    className: classnames(styles.shadowCoverTop, shadowCoverBackgroundColor(props))
  }), props.children, React.createElement("li", {
    id: "scrollShadowBottom",
    "aria-hidden": true,
    className: classnames(styles.shadowCoverBottom, shadowCoverBackgroundColor(props)),
    style: props.minHeight && {
      position: 'sticky',
      top: props.minHeight
    }
  })));
});